import { render, staticRenderFns } from "./sidentify.vue?vue&type=template&id=5ab0def5"
import script from "./sidentify.vue?vue&type=script&lang=js"
export * from "./sidentify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports